import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/workspace/web/layouts/default.vue"))
}